import { io } from "socket.io-client";
import { useEffect, useRef, useState } from "react";

const socket = io("https://darajaapi-2.onrender.com", {
    transports: ["websocket"],
});

function New() {

    const myID = 8655
    const sender = 'Kingston'
    const room = 26
    const health_bar = 100
    const victim = 94
    const Taker_id = 88
    const amount_taken = 100
    const coins = 200

      const sentRef = useRef(false);
   
        const [players, setPlayers] = useState([]);

     useEffect(()=>{
 

        // Join a room
         socket.emit("join_game", room);
       

     },[])

     useEffect(() => {

    socket.on("connect", () => {
        console.log("Connected", socket.id);
    });

    socket.on("disconnect", (reason) => {
        console.log("Disconnected:", reason);
    });

    socket.on("connect_error", (err) => {
        console.log(err.message);
    });

}, []);
       
     useEffect(() => {
   
       if (sentRef.current) return;
       sentRef.current = true;
   
       socket.emit("push_array", {
         myID,
         sender,
         room,
         health: 50,
         victim,
         Taker_id,
         amount_taken: 100,
         coins,
       });
   
     }, []);
   
   useEffect(() => {

    const handleArray = (data) => {
        setPlayers(data);
    };

    socket.on("array", handleArray);

    return () => {
        socket.off("array", handleArray);
    };

}, []);
  // bomb_message
   
     const send = () => {
      //alert('good')
            socket.emit("update_eliminated_vengence", {
   
               myID, // collection.myID
               sender, // colection.myname,
               room, //collection.room
               health: health_bar,
               victim,
               Taker_id,
               amount_taken
               
              });
     }
  return (
    <div>
        <button onClick={send}>Send Freeze</button>

        {players.filter((player) => player.eliminated == "no").map((player, index) => (

        
        <div key={index} style={{ border: "1px solid #ccc", margin: 10, padding: 10 }}>
          <p><strong>Name:</strong> {player.name}</p>
          <p><strong>ID:</strong> {player.ID}</p>
          <p><strong>Health:</strong> {player.health}</p>
          <p><strong>Room:</strong> {player.game_room}</p>
          <p><strong>shiled:</strong> {player.shield}</p>
        </div>
      ))}
    </div>
  )
}

export default New